import React, { useState, useEffect } from "react";

interface Props {
  children?: React.ReactElement | React.ReactElement[];
  className?: string;
}

const ChatLink = ({ children, className }: Props) => {
  const [currentUrl, setCurrentUrl] = useState("");

  useEffect(() => {
    setCurrentUrl(window.location.pathname);
  }, []);

  const handleChatLinkClick = (event: React.SyntheticEvent) => {
    event.preventDefault();

    window.open(
      `/chat/?referringURL=${encodeURIComponent(currentUrl)}`,
      "",
      "width=650,height=700,resizable=1,scrollbars=1",
    );
  };

  return (
    <a
      href={`/chat/?referringURL=${encodeURIComponent(currentUrl)}`}
      onClick={handleChatLinkClick}
      target="_blank"
      className={className}
    >
      {children || "Start a Live Chat"}
    </a>
  );
};

export default ChatLink;
